import React, { ChangeEvent } from "react";
import { Grid, List, MenuItem, MenuList, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
import { EventAutocompleteOption } from "../../globalSettings/types";

type Props = {
  options: EventAutocompleteOption[];
  onChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onSelect: (eventEditionId: string) => void;
}

const EventList = ({ options, onChange, onSelect }: Props) => {
  const { t } = useTranslation("common");

  return (
    <List className={'event-edition-list'}>
      <Grid className={'searcher-container'}>
        <SearchIcon fontSize="small" className={'search-icon'}/>
        <TextField autoFocus placeholder={t("headTitles.search")} autoComplete="one-time-code" className={'searcher'} onChange={onChange} />
      </Grid>
      <MenuList className={'list-container'}>
        {options.map((item, key) =>
          <MenuItem
            key={key}
            aria-selected tabIndex={0}
            className={'list-item'}
            onClick={() => onSelect(item.atlasId)}
          >
            {item.gbsCode}{': '}{item.label}
          </MenuItem>)}
      </MenuList>
    </List>
  );
};

export default EventList;
